export default {
    forbidden: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/forbidden',
        name: '用户票券禁用/解禁',
    },
    unForbidden: {
        url: "/manage-system/userTicket/operate/relieveForbidden",
        name: '用户票券解禁',
        method: 'POST',
    },
    increase: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/numGive',
        name: '赠送次数',
    },
    userTicketSearch: {
        method: 'GET',
        url: '/manage-system/user-ticket/page-list',
        name: '购票订单分页查询',
    },
    ownerChange: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/ownerChange',
        name: '持有者更改',
    },
    ticketRefund: {
        method: 'POST',
        url: '/admin/userTicket/refund',
        name: '用户票券退款',
    },
    ticketUpgrade: {
        method: 'POST',
        url: '/admin/userTicket/upgrade',
        name: '用户票券升级',
    },
    validityReset: {
        method: 'GET',
        url: '/admin/userTicket/validityReset/{id}/{effectiveDate}/{expirationDate}',
        name: '有效期重置',
    },
    detailUserTicket: {
        method: 'GET',
        url: '/manage-system/userTicket/query/getUserTicketDetail/{userTicketNo}',
        name: '票券详细信息',
    },
    consumeSearch: {
        method: 'POST',
        url: '/admin/consume/consumeSearch',
        name: '票券消费分页查询（所有票券）',
    },
    countReturn: {
        method: 'POST',
        url: '/manage-system/userTicket/verify/userTicketNumReturn',
        name: '次数退还',
    },
    courseReserveList: {
        method: 'POST',
        url: '/admin/consume/courseReserveList',
        name: '查询课程预约名单',
    },
    useRecord: {
        method: 'POST',
        url: '/admin/consume/useRecord',
        name: '票券消费记录分页查询（单独票券）',
    },
    bill: {
        method: 'GET',
        url: '/admin/order/bill/{orderId}',
        name: '零售订单',
    },
    billRefund: {
        method: 'POST',
        url: '/admin/order/orderRefund',
        name: '零售订单退款',
    },
    billRetailSearch: {
        method: 'POST',
        url: '/manage-system/order/retailSearch',
        name: '零售订单分页查询',
    },
    courseOrder: {
        method: 'POST',
        url: '/admin/consume/courseOrder',
        name: '课程订单分页查询',
    },
    cancelVerify: {
        method: 'POST',
        url: '/admin/consume/cancelVerify',
        name: '取消核销',
    },
    verify: {
        method: 'POST',
        url: '/admin/consume/verify',
        name: '核销',
    },
    cancelReserve: {
        method: 'POST',
        url: '/manage-system/userTicket/reserve/userTicketCancelReserve',
        name: '取消预约',
    },
    ticketSearch: {
        method: 'POST',
        url: '/manage-system/order/ticketSearch',
        name: '票券课程订单分页查询',
    },
    orderSearch: {
        method: "GET",
        url: "/manage-system/trade-order/page-list",
        name: "分页查询交易订单信息"
    },
    tradeDetail: {
        method: 'GET',
        url: "/manage-system/buy/trade/{transNo}",
        name: '交易 详情',
    },
    getOrderDetail: {
        method: 'POST',
        url: '/manage-system/order/viewTradeTicket',
        name: '票券 交易 详情',
    },
    getGivedDetail: {
        method: "POST",
        url: "/manage-system/order/getGiveGrantDetailVos",
        name: "用户主票获取赠品记录"
    },
    refundOrderList: {
        method: "POST",
        url: "/manage-system/reimburse/refund",
        name: "发起退款",
    },
    getTicketOrderList: {
        method: 'GET',
        url: '/manage-system/reserve/page-list',
        name: '票券预约记录查询',
    },
    getTicketVerifyList: {
        method: 'GET',
        url: '/manage-system/verify/page-list',
        name: '票券核销记录查询',
    },
    getUserTicketUseRecordList: {
        method: 'GET',
        url: '/manage-system/userTicket/query/getUserTicketUseRecordList/{userTicketNo}',
        name: '用户票券使用记录列表',
    },
    ticketOrderExport: {
        method: 'GET',
        url: '/manage-system/reserve/export',
        name: '导出信息票券核销记录',
    },
    ticketVerifyExport: {
        method: 'GET',
        url: '/manage-system/verify/export',
        name: '导出信息票券核销记录',
    },
    search: {
        method: 'POST',
        url: '/manage-system/userTicket/query/queryUserTicketUseLogVoPage',
        name: '票券消费记录查询',
    },
    opRecord: {
        method: 'POST',
        url: '/manage-system/userTicket/query/queryUserTicketOperateLogVoPage',
        name: '票券操作记录查询',
    },
    orderVerify: {
        method: 'GET',
        url: '/admin/course/verify/{consumeId}',
        name: '课程核销(强制核销)',
    },
    mealOrderSearch: {
        method: 'POST',
        url: '/admin/cater/caterOrderSearch',
        name: '餐饮订单记录查询',
    },
    mealOrderDetail: {
        method: 'GET',
        url: '/admin/cater/caterOrderDetail/{id}',
        name: '餐饮订单详情',
    },
    mealOrderRefund: {
        method: 'POST',
        url: '/admin/cater/caterOrderRefund',
        name: '餐饮订单退款',
    },
    ticketSearchExport: {
        method: 'POST',
        url: '/admin/order/ticketSearch/export',
        name: '票券课程订单分页导出',
    },
    retailSearchExport: {
        method: 'POST',
        url: '/admin/order/retailSearch/export',
        name: '零售订单分页导出',
    },
    searchExport: {
        method: 'POST',
        url: '/admin/consume/search/export',
        name: '票券消费记录分页查询导出',
    },
    orderSearchExport: {
        method: 'GET',
        url: '/manage-system/user-ticket/export',
        name: '用户票券管理列表导出',
    },
    orderExport: {
        method: 'GET',
        url: "/manage-system/trade-order/export",
        name: '订单列表导出',
    },
    mealOrderExport: {
        method: 'POST',
        url: '/admin/cater/caterOrderSearch/export',
        name: '导出餐饮订单',
    },
    storedValueOrderSeach: {
        method: 'POST',
        url: '/admin/order/storedValueOrderSeach',
        name: '储值订单分页查询',
    },
    storedValueOrderSearchNew: {
        method: 'POST',
        url: '/manage-system/order/balanceOrderSearch',
        name: '储值订单分页查询',
    },
    caterOrderTotal: {
        method: 'POST',
        url: '/admin/cater/caterOrderTotal',
        name: '当日餐饮订单金额统计',
    },
    userTicketGiveDetails: {
        method: 'GET',
        url: '/admin/order/userTicketGiveDetails/{userTicketId}',
        name: '获得票券赠送详情列表',
    },
    viewTrade: {
        method: 'POST',
        url: '/manage-system/order/viewTrade',
        name: '查看订单',
    },
    userTicketOrderUpgrade: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/upgrade',
        name: '用户票券升级订单',
    },
    upTicketList: {
        method: 'GET',
        url: '/manage-system/ticket/getAllowUpgradeTicketByShop/{ticketId}/{shopId}',
        name: '用户票券升级票券列表',
    },
    newValidityReset: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/validityReset',
        name: '新票券有效期重置',
    },
    payAfterSalesOrder: {
        method: 'POST',
        url: '/manage-system/buy/payOrder',
        name: '支付售后订单',
    },
    createTicketFrozenOrder: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/frozen',
        name: '创建票券冻结订单',
    },
    ticketFrozenInfo: {
        method: 'GET',
        url: '/manage-system/userTicket/operate/getTicketFrozenInfo/{userTicketNo}',
        name: '票券冻结信息',
    },
    userTicketThaw: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/advanceThaw',
        name: '用户票券解冻',
    },
    userTicketCancelFrozen: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/cancelFrozen',
        name: '用户票券取消冻结',
    },
    getUserTicketGiveInfoVo: {
        method: 'GET',
        url: '/admin/ticketGive/getUserTicketGiveInfoVo/{userTicketId}',
        name: '获取用户票券赠品的信息',
    },
    getTicketGiveInfoVo: {
        method: 'GET',
        url: '/admin/ticketGive/getTicketGiveInfoVo',
        name: '获取票券活动信息',
    },
    payOrder: {
        method: 'PUT',
        url: '/admin/order/payOrder',
        name: '支付订单',
    },
    checkOrderGiveRefund: {
        method: 'GET',
        url: '/admin/order/checkOrderGiveRefund/{orderId}/{ignoreNotEnough}',
        name: '验证订单赠品退款',
    },
    userTicketByAfterSalesOrder: {
        method: 'POST',
        url: '/admin/userTicket/userTicketByAfterSalesOrder',
        name: '售后订单查询用户票券',
    },
    getPhoneList: {
        method: 'GET',
        url: '/admin/member/getPhoneList/{phone}',
        name: '会员手机号列表模糊查询(只查20条记录)',
    },
    getRefundDetail: {
        method: 'GET',
        url: '/manage-system/order/orderTicket/{orderNo}',
        name: '用户票券退款详情',
    },
    getVerifyReserveList: {
        method: "POST",
        url: "/manage-system/userTicket/reserve/queryUserTicketReservePage",
        name: "分页查询用户预约记录",
    },
    queryShopAllActivityTicketFromUpgrade: {
        method: "POST",
        url: "/manage-system/give/admin/queryShopAllActivityTicketFromUpgrade",
        name: "升级操作获取某门店下所有有效的售卖的买赠活动的票券",
    },
    exportRecord: {
        method: "POST",
        url: "/manage-system/export/list",
        name: "查询导出记录",
    },
    exportDownload: {
        method: "POST",
        url: "/manage-system/export/download",
        name: "登录用户下载更新",
    },
    pointOrderExport: {
        method: "GET",
        url: "/manage-system/trade-order/pointOrder/export",
        name: "导出积分交易单信息",
    },
    partyOrderPage: {
        method: "POST",
        url: "/manage-system/partyOrder/page",
        name: "派对订单分页",
    },
    partyOrderCreate: {
        method: "POST",
        url: "/manage-system/partyOrder/save",
        name: "派对订单新增",
    },
    partyOrderDetail: {
        method: "GET",
        url: "/manage-system/partyOrder/detail/{id}",
        name: "派对订单详情",
    },
    partyOrderUpdate: {
        method: "POST",
        url: "/manage-system/partyOrder/update",
        name: "派对订单编辑",
    },
    partyOrderGetTitle: {
        method: "GET",
        url: "/manage-system/partyOrder/getTitle",
        name: "模糊获取主题",
    },
    partyOrderProceedsSave0: {
        method: "POST",
        url: "/manage-system/partyOrderProceeds/save0",
        name: "收款保存",
    },
    partyOrderProceedsSave1: {
        method: "POST",
        url: "/manage-system/partyOrderProceeds/save1",
        name: "补收款保存",
    },
    partyOrderProceedsData: {
        method: "GET",
        url: "/manage-system/partyOrderProceeds/list",
        name: "收款记录",
    },
    partyOrderRefundSave0: {
        method: "POST",
        url: "/manage-system/partyOrderRefund/save0",
        name: "退款保存",
    },
    partyOrderRefundSave1: {
        method: "POST",
        url: "/manage-system/partyOrderRefund/save1",
        name: "补退款保存",
    },
    partyOrderRefundData: {
        method: "GET",
        url: "/manage-system/partyOrderRefund/list",
        name: "退款记录",
    },
    partyOrderOperationLog: {
        method: "GET",
        url: "/manage-system/operationLog/list",
        name: "操作记录",
    },
    partyOrderProceedsGetFiles: {
        method: "GET",
        url: "/manage-system/partyOrderProceeds/getFiles",
        name: "查看附件",
    },
    partyOrderProceedsFilesDownload: {
        method: "GET",
        url: "/manage-system/partyOrderProceeds/download",
        name: "打包下载",
    },
    partyOrderRefundGetFiles: {
        method: "GET",
        url: "/manage-system/partyOrderRefund/getFiles",
        name: "查看附件",
    },
    partyOrderRefundFilesDownload: {
        method: "GET",
        url: "/manage-system/partyOrderRefund/download",
        name: "打包下载",
    },
    partyOrderRefundCancel: {
        method: "POST",
        url: "/manage-system/partyOrder/cancel",
        name: "派对订单取消",
    },
    partyOrderArchive: {
        method: "POST",
        url: "/manage-system/partyOrder/archive",
        name: "派对订单归档",
    },
    partyOrderGetArchive: {
        method: "GET",
        url: "/manage-system/partyOrder/getArchive",
        name: "派对订单归档信息",
    },
    userTicketOperateDelay: {
        method: "POST",
        url: "/manage-system/userTicket/operate/delay",
        name: "票券过期延期"
    },
    getTicketNewestDelayTime: {
        method: "GET",
        url: "/manage-system/userTicket/operate/getTicketNewestDelayTime/{userTicketNo}",
        name: "获取票券最新的延期记录"
    },
    getOrderDYMT: {
        method: "GET",
        url: "/manage-system/sys/third-order/meituan/trade/page",
        name: "获取美团订单"
    },
    reverseMT: {
        method: "POST",
        url: "/manage-system/sys/third-order/meituan/trade/receipt/reverse/consume",
        name: "美团撤销验券"
    },
}
